import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Prayer from "./pages/Prayer";
import Quran from "./pages/Quran";
import Names from "./pages/Names";
import Dhikr from "./pages/Dhikr";
import Hijri from "./pages/Hijri";
import Prophets from "./pages/Prophets";
import Qibla from "./pages/Qibla";
import Duas from "./pages/Duas";
import Arabic from "./pages/Arabic";
import Tafsir from "./pages/Tafsir";
import Quiz from "./pages/Quiz";
import Game from "./pages/Game";
import Values from "./pages/Values";
import More from "./pages/More";
import SacredNights from "./pages/SacredNights";
import Zakat from "./pages/Zakat";
import Hifz from "./pages/Hifz";
import Mosques from "./pages/Mosques";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/prayer" element={<Prayer />} />
            <Route path="/quran" element={<Quran />} />
            <Route path="/names" element={<Names />} />
            <Route path="/dhikr" element={<Dhikr />} />
            <Route path="/hijri" element={<Hijri />} />
            <Route path="/prophets" element={<Prophets />} />
            <Route path="/qibla" element={<Qibla />} />
            <Route path="/duas" element={<Duas />} />
            <Route path="/arabic" element={<Arabic />} />
            <Route path="/tafsir" element={<Tafsir />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/game" element={<Game />} />
            <Route path="/values" element={<Values />} />
            <Route path="/sacred-nights" element={<SacredNights />} />
            <Route path="/zakat" element={<Zakat />} />
            <Route path="/hifz" element={<Hifz />} />
            <Route path="/mosques" element={<Mosques />} />
            <Route path="/more" element={<More />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
